import React, { Component } from 'react';
import { Modal, Form, Button, Input } from 'antd';

export default function AddBarcode({ open, onCancel, title, updateGuideline, loading }) {
    const [form] = Form.useForm();

    const HandleFinish = data => {
        const { barcode, comment } = data;
        updateGuideline(barcode, comment);
        form.setFieldValue('barcode', '');
        form.setFieldValue('comment', '');
    };
    return (
        <>
            <Modal title={`Add Barcode to : ${title}`} open={open} onCancel={onCancel} footer={null} width="80%">
                <div style={{ width: '100%', height: '70vh' }}>
                    <Form form={form} onFinish={HandleFinish}>
                        <Form.Item label="Barcode" name="barcode" colon={true}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Comments" name="comment" colon={true}>
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit" hidden={true} disabled={loading} loading={loading}>
                                Add Barcode
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
